import InfiniteLoader from 'Components/Elements/InfiniteLoader';
import {
  PageBoxesStateData,
  actions,
} from 'core/redux/features/boxes/pageBoxes';
import { DeviceType } from 'core/redux/features/shared/types';
import { AppState } from 'core/redux/reducers';
import { querySelectorAll } from 'dom-helpers';

import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'utils/createSlider/index.scss';
import Item, { PageBoxItemLoader } from './Item';

// const mapStateToProps = (state: AppState) => ({
//   entities: state.pageBoxes.results,
//   deviceType: state.deviceType,
//   tokens: state.tokens?.box ?? {},
//   local: state.local,
// });
//
// const mapDispatchToProps = {
//   loadNextPage: actions.nextPageRequest,
//   updateParams: actions.updateParams,
// };
//
// interface IOwnProps {
//   position?: string;
//   itemClassName?: string;
//   loadingCount?: number;
//   loaderComponent?: React.ReactElement;
// }
//
// type TProps = IOwnProps &
//   ReturnType<typeof mapStateToProps> &
//   typeof mapDispatchToProps;

const PageBoxLoading = React.memo(
  (props: { deviceType: DeviceType; count: number }) => {
    const loadingItems = [];
    for (let i = props.count; i > 0; i--) {
      loadingItems.push(
        <PageBoxItemLoader key={i} deviceType={props.deviceType} />,
      );
    }

    return <>{loadingItems}</>;
  },
);

interface IPageBoxesProps {
  position?: string;
  itemClassName?: string;
  loadingCount?: number;
  loaderComponent?: React.ReactElement;
}

export const PageBoxes = ({
  position = 'bottom',
  itemClassName = '',
  loadingCount = 1,
  loaderComponent,
}: IPageBoxesProps) => {
  const { entities, deviceType, local } = useSelector((state: AppState) => ({
    entities: state.pageBoxes.results,
    deviceType: state.deviceType,
    // tokens: state.tokens?.box ?? {},
    local: state.local,
  }));

  const { next_page, loading, data, params } = entities[position];

  const dispatch = useDispatch();
  useEffect(() => {
    if (params.position !== position) {
      dispatch(
        actions.updateParams(
          {
            local,
            position: position,
          },
          position,
        ),
      );
    }
  }, [dispatch, params, local, position]);

  const createSliderRef = useRef<any>();

  const loadSlider = async (
    _item: PageBoxesStateData,
    refElem: HTMLElement,
  ) => {
    if (querySelectorAll(refElem, '.ebslider').length === 0) {
      return;
    }

    if (!createSliderRef.current) {
      try {
        createSliderRef.current = (await import('utils/createSlider')).default;
      } catch (e) {
        console.error(e);
      }
    }

    createSliderRef.current(refElem);
  };

  const loadTrustPilot = (
    item: PageBoxesStateData,
    refElem: HTMLElement,
    retryCount = 0,
  ) => {
    const elems = querySelectorAll(refElem, '.trustpilot-widget');

    if (elems.length === 0) {
      return;
    }

    if (!window.Trustpilot) {
      // retry up to 10 times
      if (retryCount < 10) {
        setTimeout(() => {
          loadTrustPilot(item, refElem, retryCount + 1);
        }, 1000);
      }

      return;
    }

    elems.forEach(el => {
      window.Trustpilot.loadFromElement(el);
    });
  };

  const loadEmbedSocial = (_item: PageBoxesStateData, refElem: HTMLElement) => {
    const elems = querySelectorAll(refElem, '.embedsocial-reviews');
    if (elems.length === 0) {
      return;
    }

    setTimeout(() => {
      (function (d, s, id) {
        var js;
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://embedsocial.com/embedscript/ri.js';
        d.getElementsByTagName('head')[0].appendChild(js);
      })(document, 'script', 'EmbedSocialReviewsScript');
    }, 100);
  };

  const onItemDidMount = async (
    item: PageBoxesStateData,
    refElem: HTMLElement,
  ) => {
    loadTrustPilot(item, refElem);
    loadEmbedSocial(item, refElem);
    await Promise.all([loadSlider(item, refElem)]);
  };

  return (
    <InfiniteLoader
      hasNextPage={next_page !== null}
      loading={loading}
      items={data}
      loader={
        loaderComponent ?? (
          <PageBoxLoading count={loadingCount} deviceType={deviceType} />
        )
      }
      loadNextPage={() => {
        dispatch(
          actions.nextPageRequest(
            {
              position: position,
              device: deviceType === 'mobile' ? 'mobile' : 'desktop',
            },
            position,
          ),
        );
      }}
    >
      {({ item }) => {
        return (
          <Item
            onMount={onItemDidMount}
            className={itemClassName}
            item={item}
          />
        );
      }}
    </InfiniteLoader>
  );
};

// class PageBoxesComponent extends Component<TProps> {
//   static defaultProps = {
//     position: 'bottom',
//     itemClassName: '',
//     loadingCount: 1,
//   };
//   private createSlider: any;
//
//   componentDidMount(): void {
//     const { entities, position, local } = this.props;
//     if (entities[position].params.position !== this.props.position) {
//       this.props.updateParams(
//         {
//           local,
//           position: this.props.position,
//         },
//         position,
//       );
//     }
//   }
//
//   loadNextPage = () => {
//     this.props.loadNextPage(
//       {
//         position: this.props.position,
//         device: this.props.deviceType === 'mobile' ? 'mobile' : 'desktop',
//       },
//       this.props.position,
//     );
//   };
//
//   /**
//    * Handle item mound event
//    * When it mount we will apply the slider
//    * @param item
//    * @param refElem
//    */
//   onItemDidMount = async (item: PageBoxesStateData, refElem: HTMLElement) => {
//     if (querySelectorAll(refElem, '.ebslider').length === 0) {
//       return;
//     }
//
//     if (!this.createSlider) {
//       try {
//         this.createSlider = (await import('utils/createSlider')).default;
//       } catch (e) {
//         console.error(e);
//       }
//     }
//
//     this.createSlider(refElem);
//   };
//
//   render() {
//     const {
//       entities,
//       deviceType,
//       itemClassName,
//       loadingCount,
//       position,
//       loaderComponent,
//     } = this.props;
//     const { next_page, loading, data } = entities[position];
//
//     return (
//       <InfiniteLoader
//         hasNextPage={next_page !== null}
//         loading={loading}
//         items={data}
//         loader={
//           loaderComponent ?? (
//             <PageBoxLoading count={loadingCount} deviceType={deviceType} />
//           )
//         }
//         loadNextPage={this.loadNextPage}
//       >
//         {({ item }) => {
//           return (
//             <Item
//               onMount={this.onItemDidMount}
//               className={itemClassName}
//               item={item}
//             />
//           );
//         }}
//       </InfiniteLoader>
//     );
//   }
// }

// const PageBoxes = connect(
//   mapStateToProps,
//   mapDispatchToProps,
// )(PageBoxesComponent);
export default PageBoxes;
